export default __webpack_public_path__ + "static/media/method-img.ab1d2bf6.png";